export class PaymentProcessorModel {
    public id: string;
    public ImagePath: string;
    public active: boolean;
    public numberOfMemberships: number;
    public numberOfPayments: number;
    public paymentProcessorName: string;
    public processorWebUrl: string;
    public sumOfPayments: number;
    public countryIds :Array<any> =new Array<any>(); 
    // public countryNames :Array<string>; 
}
